import { DialogService } from 'primeng/dynamicdialog';
import { LoginComponent } from 'src/app/module/auth/pages/login/login.component';

/** Abre o modal de login padronizado, opcionalmente guardando o destino pós-login. */
export function openLoginDialog(dialogService: DialogService, returnUrl?: string) {
  return dialogService.open(LoginComponent, {
    header: 'Login',
    width: 'min(92vw, 500px)',
    height: 'auto',
    modal: true,
    closable: true,
    closeOnEscape: true,
    dismissableMask: true,
    showHeader: true,
    styleClass: 'login-modal-custom',
    style: { 'max-width': '500px', 'border-radius': '12px' },
    contentStyle: {
      overflow: 'hidden',
      display: 'flex',
      'flex-direction': 'column',
      'min-height': '0',
    },
    position: 'center',
    data: returnUrl ? { returnUrl } : {},
  });
}
